import { call, put, select } from 'redux-saga/effects';
import { User, UserId } from 'features/users/types';
import { notification } from 'features/notifications/toast/notification';
import i18n from 'i18n';
import { selectLocalUserId, selectUserById, userLeft } from 'features/users/usersSlice';
import { selectRoomId } from 'features/room/roomSlice';
import { logger } from 'utils/logger';
import {
  broadcastPermissionRevoked,
  signalingBroadcastDisallowed,
} from 'features/permissions/actions';
import { onBroadcastEndSaga } from 'features/layout/sagas/onBroadcastEndSaga';

export function* onBroadcastDisallowedSaga({
  payload,
}: ReturnType<typeof signalingBroadcastDisallowed>) {
  const { data, initiator } = payload;

  const localUserId: UserId = yield select(selectLocalUserId);
  const roomId: string = yield select(selectRoomId);

  const remoteUserIds: UserId[] = [];

  for (const id of data.users) {
    if (localUserId === id) {
      logger
        .remote({ tier: 1 })
        .info(`The user was disallowed to broadcast by user id=${initiator.id}`);

      const initiatorUser: User = yield select(selectUserById, initiator.id);

      if (initiatorUser.name) {
        yield call(
          notification,
          i18n.t('notifications:broadcast_disallowed', { username: initiatorUser.name })
        );
      } else {
        yield call(notification, i18n.t('notifications:broadcast_disallowed_unnamed'));
      }

      yield put(broadcastPermissionRevoked({ id, initiator }));
    } else {
      remoteUserIds.push(id);
    }
  }

  if (remoteUserIds.length > 0) {
    yield call(onBroadcastEndSaga, userLeft(remoteUserIds.map((userId) => ({ userId, roomId }))));
  }
}
